// extracted by mini-css-extract-plugin
export default {"CrossReference":"CrossReference_CrossReference__J7Q6N","label":"CrossReference_label__QQLza","reference":"CrossReference_reference__sZ7O0"};